import { render, staticRenderFns } from "./childtemplate.vue?vue&type=template&id=772c9dbb&scoped=true"
import script from "./childtemplate.vue?vue&type=script&lang=js"
export * from "./childtemplate.vue?vue&type=script&lang=js"
import style0 from "./childtemplate.vue?vue&type=style&index=0&id=772c9dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c9dbb",
  null
  
)

export default component.exports